<template>
  <div class="mx-4 mb-16 pb-6 position-relative">
    <v-card class="ma-0 pa-0 elevation-0">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="poppins text-dark-75 font-size-h3">{{
          $t("datatable_select_all")
        }}</span>
        <div
          class="form-check form-check-sm form-check-custom form-check-solid me-8"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="select_all"
            @change="selectAllColumns"
          />
        </div>
      </v-card-title>
      <v-card-text class="px-1 py-1">
        <perfect-scrollbar class="scroll overflow-y-hidden py-0">
          <draggable
            tag="div"
            :list="columns_to_export"
            class=""
            handle=".dragger"
            :force-fallback="true"
            :fallback-on-body="true"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition" name="flip-list">
              <v-card
                outlined
                class="px-2 py-5 mx-1 mb-4 d-flex align-center justify-space-between"
                v-for="(element, idx) in columns_to_export"
                :key="idx"
              >
                <div class="d-flex align-center">
                  <i class="dragger"><v-icon>mdi-menu</v-icon></i>
                  <div class="ps-2 poppins font-size-h6 font-size-h5-sm">
                    {{ element.text }}
                  </div>
                </div>

                <div
                  class="form-check form-check-sm form-check-custom form-check-solid me-8"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="element.selected"
                    @change="updateData"
                  />
                </div>
              </v-card>
            </transition-group>
          </draggable>
        </perfect-scrollbar>
      </v-card-text>

      <v-card-title class="d-flex justify-space-between align-center">
        <span class="poppins text-dark-75 font-size-h3">{{
          $t("set_as_default_template")
        }}</span>
        <div
          class="form-check form-check-sm form-check-custom form-check-solid me-8"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="defaultExportTemplate"
            @change="setDefaultExportTemplate"
          />
        </div>
      </v-card-title>
    </v-card>

    <div
      class="w-100 pa-6 bg-white d-flex justify-center align-center position-fixed zindex-5 bottom-0 end-0"
    >
      <div class="w-50 me-4">
        <button
          @click="toggleModal"
          class="w-100 btn btn--export-filter d-flex align-center justify-center poppins font-size-lg line-height-xl ls1 text-uppercase"
        >
          <span class="svg-icon">
            <v-icon size="24"> mdi-chevron-left </v-icon>
          </span>
          {{ $t("clear") }}
        </button>
      </div>
      <div class="w-50 me-1">
        <button
          class="w-100 btn iq-btn poppins text-no-wrap font-size-lg line-height-xl ls1 text-uppercase"
          @click.prevent="exportColumns"
        >
          {{ $t("export") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import { SET_DEFAULT_EXPORT_TEMPLATE } from "@/core/services/store/orders.module";

export default {
  name: "Export",
  props: {
    headers: {
      required: true,
      type: Array,
    },
    downloadItem: {
      required: true,
      type: Function,
    },
  },
  components: { draggable },
  data: () => ({
    defaultExportTemplate: false,
    // isDragging: false,
    select_all: false,
    export_modal: false,
    columns_to_export: [],
  }),
  mounted() {
    this.initiate();
  },
  beforeDestroy() {
    this.columns_to_export = [];
  },
  // computed: {
  //   dragOptions() {
  //     return {
  //       animation: 0,
  //       group: "description",
  //       disabled: false,
  //       ghostClass: "ghost",
  //     };
  //   },
  // },
  methods: {
    setDefaultExportTemplate() {
      this.$store.commit(
        SET_DEFAULT_EXPORT_TEMPLATE,
        this.defaultExportTemplate
      );
    },
    initiate() {
      if (this.columns_to_export?.length) return;
      this.columns_to_export = this.headers?.map((col) => {
        if (col?.hasOwnProperty("is_export_default")) {
          return {
            text: col.text,
            value: col.value,
            selected: col.is_export_default,
          };
        } else {
          return {
            text: col.text,
            value: col.value,
            selected: true,
          };
        }
      });
    },
    /**
     * to trigger computed data!
     */
    updateData() {
      this.columns_to_export = [...this.columns_to_export];
    },
    /**
     * convert data to old format to be compatible
     */
    convertToOldStyle() {
      let data = [];
      this.columns_to_export?.forEach((col) => {
        if (col?.selected) {
          data.push(col.value);
        }
      });
      return data;
    },
    /**
     * handle submit button action
     */
    exportColumns() {
      if (this.columns_to_export?.length > 0) {
        this.downloadItem(this.convertToOldStyle());
      } else {
        Swal.fire({
          title: this.$t("warning"),
          text: this.$t(
            "notificationmessage_please_select_at_least_one_column_to_export"
          ),
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },

    /**
     * change state of columns
     */
    selectAllColumns() {
      if (this.select_all) {
        this.columns_to_export?.forEach((col, index) => {
          this.columns_to_export[index].selected = true;
        });
      } else {
        this.columns_to_export?.forEach((col, index) => {
          this.columns_to_export[index].selected = false;
        });
      }
    },
    /**
     * toggle modal visibility
     */
    toggleModal() {
      if (!this.export_modal) {
        this.initiate();
      }
      this.export_modal = !this.export_modal;
    },
    /**
     * is all columns are selected
     * @return {Boolean}
     */
    isAllColumnsSelected() {
      let is_all_selected = true;
      this.columns_to_export?.forEach((col) => {
        if (!col?.selected) {
          is_all_selected = false;
        }
      });
      return is_all_selected;
    },
    /**
     * select all state manager
     */
    handleSelectAllState() {
      if (this.isAllColumnsSelected()) {
        this.select_all = true;
      } else {
        this.select_all = false;
      }
    },
  },
  watch: {
    columns_to_export: function () {
      this.handleSelectAllState();
    },
  },
};
</script>

<style scoped>
.dragger {
  cursor: move;
}
</style>
